// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Alerts Page Styles
 * Styles for the alerts management page
 */

/* Page Container */
.alerts-page {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  animation: fadeIn 0.3s ease-in-out;
}

/* Header */
.alerts-header__title {
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.alerts-header__description {
  color: var(--color-text-secondary);
}

/* Stats Cards */
.alerts-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}

.alerts-stat-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.alerts-stat-card__icon {
  padding: 0.75rem;
  border-radius: var(--radius-lg);
  flex-shrink: 0;
}

.alerts-stat-card__icon svg {
  width: 1.5rem;
  height: 1.5rem;
}

.alerts-stat-card__icon--danger {
  background-color: var(--color-danger-100);
  color: var(--color-danger-600);
}

.dark .alerts-stat-card__icon--danger {
  background-color: rgba(220, 38, 38, 0.2);
  color: var(--color-danger-400);
}

.alerts-stat-card__icon--warning {
  background-color: var(--color-warning-100);
  color: var(--color-warning-600);
}

.dark .alerts-stat-card__icon--warning {
  background-color: rgba(234, 179, 8, 0.2);
  color: var(--color-warning-400);
}

.alerts-stat-card__icon--success {
  background-color: var(--color-primary-100);
  color: var(--color-primary-600);
}

.dark .alerts-stat-card__icon--success {
  background-color: rgba(37, 99, 235, 0.2);
  color: var(--color-primary-400);
}

.alerts-stat-card__value {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.alerts-stat-card__label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

/* Tabs */
.alerts-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  border-bottom: 1px solid var(--color-gray-200);
  padding-bottom: 1rem;
}

.dark .alerts-tabs {
  border-bottom-color: var(--color-slate-700);
}

.alerts-tab {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: var(--radius-lg);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  border: none;
  cursor: pointer;
  transition: var(--transition-base);
}

.alerts-tab--active {
  background-color: var(--color-primary-600);
  color: #ffffff;
}

.alerts-tab:not(.alerts-tab--active) {
  background-color: var(--color-gray-200);
  color: var(--color-gray-700);
}

.dark .alerts-tab:not(.alerts-tab--active) {
  background-color: var(--color-slate-700);
  color: var(--color-gray-300);
}

.alerts-tab:not(.alerts-tab--active):hover {
  background-color: var(--color-gray-300);
}

.dark .alerts-tab:not(.alerts-tab--active):hover {
  background-color: var(--color-slate-600);
}

.alerts-tab__count {
  padding: 0.125rem 0.5rem;
  border-radius: 9999px;
  font-size: var(--font-size-xs);
  background-color: rgba(255, 255, 255, 0.3);
}

.alerts-tab--active .alerts-tab__count {
  background-color: #ffffff;
  color: var(--color-primary-600);
}

.alerts-tab:not(.alerts-tab--active) .alerts-tab__count {
  background-color: var(--color-gray-300);
}

.dark .alerts-tab:not(.alerts-tab--active) .alerts-tab__count {
  background-color: var(--color-slate-600);
}

/* Alerts List */
.alerts-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Empty State */
.alerts-empty {
  text-align: center;
  padding: 3rem 0;
}

.alerts-empty__icon {
  width: 4rem;
  height: 4rem;
  margin: 0 auto 1rem;
  color: var(--color-gray-400);
}

.dark .alerts-empty__icon {
  color: var(--color-gray-600);
}

.alerts-empty__title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
  margin-bottom: 0.5rem;
}

.alerts-empty__description {
  color: var(--color-text-secondary);
}

/* Alert Card Component */
.alert-card {
  border-left-width: 4px;
  border-radius: var(--radius-lg);
  padding: 1rem;
  cursor: pointer;
  transition: all 0.2s;
}

.alert-card--danger {
  background-color: var(--color-danger-50);
  border-left-color: var(--color-danger-500);
}

.dark .alert-card--danger {
  background-color: rgba(220, 38, 38, 0.1);
}

.alert-card--danger:hover {
  background-color: var(--color-danger-100);
}

.dark .alert-card--danger:hover {
  background-color: rgba(220, 38, 38, 0.2);
}

.alert-card--warning {
  background-color: var(--color-warning-50);
  border-left-color: var(--color-warning-500);
}

.dark .alert-card--warning {
  background-color: rgba(234, 179, 8, 0.1);
}

.alert-card--warning:hover {
  background-color: var(--color-warning-100);
}

.dark .alert-card--warning:hover {
  background-color: rgba(234, 179, 8, 0.2);
}

.alert-card--acknowledged {
  opacity: 0.75;
}

.alert-card__content {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.alert-card__icon {
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.alert-card__icon svg {
  width: 1.25rem;
  height: 1.25rem;
}

.alert-card__icon--danger {
  color: var(--color-danger-500);
}

.alert-card__icon--warning {
  color: var(--color-warning-500);
}

.alert-card__body {
  flex: 1 1;
  min-width: 0;
}

.alert-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.alert-card__title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.alert-card__badge {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  border-radius: var(--radius-sm);
  margin-top: 0.25rem;
  color: #ffffff;
}

.alert-card__badge--danger {
  background-color: var(--color-danger-500);
}

.alert-card__badge--warning {
  background-color: var(--color-warning-500);
}

.alert-card__badge--category {
  background-color: var(--color-primary-500);
  margin-left: 0.25rem;
}

.alert-card__temp {
  font-weight: var(--font-weight-bold);
  margin-left: 0.25rem;
}

.alert-card__temp--danger {
  color: var(--color-danger-600);
}

.dark .alert-card__temp--danger {
  color: var(--color-danger-400);
}

.alert-card__temp--warning {
  color: var(--color-warning-600);
}

.dark .alert-card__temp--warning {
  color: var(--color-warning-400);
}

.alert-card__normal-range {
  margin-left: 0.5rem;
  color: var(--color-gray-500);
  font-weight: var(--font-weight-normal);
}

.dark .alert-card__normal-range {
  color: var(--color-gray-400);
}

.alert-card__details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: var(--font-size-sm);
  color: var(--color-gray-700);
}

.dark .alert-card__details {
  color: var(--color-gray-300);
}

.alert-card__detail-label {
  font-weight: var(--font-weight-medium);
}

.alert-card__time-relative {
  color: var(--color-gray-500);
  margin-left: 0.5rem;
}

.dark .alert-card__time-relative {
  color: var(--color-gray-400);
}

.alert-card__note {
  font-size: var(--font-size-xs);
  color: var(--color-gray-600);
  font-style: italic;
  margin-top: 0.5rem;
}

.dark .alert-card__note {
  color: var(--color-gray-400);
}

.alert-card__status-text {
  font-size: var(--font-size-xs);
  margin-top: 0.25rem;
}

.alert-card__status-text--acknowledged {
  color: var(--color-gray-600);
}

.dark .alert-card__status-text--acknowledged {
  color: var(--color-gray-400);
}

.alert-card__status-text--resolved {
  color: var(--color-success-600);
}

.dark .alert-card__status-text--resolved {
  color: var(--color-success-400);
}

/* Alert Modal Component */
.alert-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.5);
  animation: fadeIn 0.3s ease-in-out;
}

.alert-modal {
  background-color: #ffffff;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  max-width: 42rem;
  width: 100%;
  max-height: 90vh;
  overflow: auto;
  animation: slideIn 0.3s ease-out;
}

.dark .alert-modal {
  background-color: var(--color-slate-800);
}

.alert-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.5rem;
  border-bottom: 1px solid var(--color-gray-200);
}

.dark .alert-modal__header {
  border-bottom-color: var(--color-slate-700);
}

.alert-modal__title {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.alert-modal__subtitle {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  margin-top: 0.25rem;
}

.alert-modal__subtitle--danger {
  color: var(--color-danger-600);
}

.dark .alert-modal__subtitle--danger {
  color: var(--color-danger-400);
}

.alert-modal__subtitle--warning {
  color: var(--color-warning-600);
}

.dark .alert-modal__subtitle--warning {
  color: var(--color-warning-400);
}

.alert-modal__close {
  color: var(--color-gray-400);
  background: none;
  border: none;
  cursor: pointer;
  transition: var(--transition-fast);
}

.alert-modal__close:hover {
  color: var(--color-gray-600);
}

.dark .alert-modal__close:hover {
  color: var(--color-gray-200);
}

.alert-modal__close svg {
  width: 1.5rem;
  height: 1.5rem;
}

.alert-modal__content {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.alert-modal__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.alert-modal__field-label {
  display: block;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-gray-600);
  margin-bottom: 0.25rem;
}

.dark .alert-modal__field-label {
  color: var(--color-gray-400);
}

.alert-modal__field-value {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.alert-modal__status-badges {
  display: flex;
  gap: 0.5rem;
}

.alert-modal__status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  border-radius: 9999px;
}

.alert-modal__status-badge--acknowledged {
  background-color: var(--color-blue-100);
  color: var(--color-blue-700);
}

.dark .alert-modal__status-badge--acknowledged {
  background-color: rgba(59, 130, 246, 0.2);
  color: var(--color-blue-400);
}

.alert-modal__status-badge--resolved {
  background-color: var(--color-success-100);
  color: var(--color-success-700);
}

.dark .alert-modal__status-badge--resolved {
  background-color: rgba(34, 197, 94, 0.2);
  color: var(--color-success-400);
}

.alert-modal__status-badge--pending {
  background-color: var(--color-gray-100);
  color: var(--color-gray-700);
}

.dark .alert-modal__status-badge--pending {
  background-color: var(--color-gray-700);
  color: var(--color-gray-300);
}

.alert-modal__info-banner {
  padding: 0.75rem;
  border-radius: var(--radius-lg);
  font-size: var(--font-size-sm);
}

.alert-modal__info-banner--acknowledged {
  background-color: var(--color-blue-50);
  color: var(--color-blue-700);
}

.dark .alert-modal__info-banner--acknowledged {
  background-color: rgba(59, 130, 246, 0.1);
  color: var(--color-blue-400);
}

.alert-modal__info-banner--resolved {
  background-color: var(--color-success-50);
  color: var(--color-success-700);
}

.dark .alert-modal__info-banner--resolved {
  background-color: rgba(34, 197, 94, 0.1);
  color: var(--color-success-400);
}

.alert-modal__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.5rem;
  border-top: 1px solid var(--color-gray-200);
}

.dark .alert-modal__footer {
  border-top-color: var(--color-slate-700);
}

/* Alert Popup Component */
.alert-popup {
  border-left-width: 4px;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  padding: 1rem;
  cursor: pointer;
  transition: all 0.3s;
}

.alert-popup--exiting {
  opacity: 0;
  transform: translateX(100%);
}

.alert-popup--entering {
  opacity: 1;
  transform: translateX(0);
  animation: slideIn 0.3s ease-out;
}

.alert-popup--danger {
  background-color: var(--color-danger-50);
  border-left-color: var(--color-danger-500);
}

.dark .alert-popup--danger {
  background-color: rgba(220, 38, 38, 0.2);
  border-left-color: var(--color-danger-700);
}

.alert-popup--warning {
  background-color: var(--color-warning-50);
  border-left-color: var(--color-warning-500);
}

.dark .alert-popup--warning {
  background-color: rgba(234, 179, 8, 0.2);
  border-left-color: var(--color-warning-700);
}

.alert-popup__content {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.alert-popup__icon {
  flex-shrink: 0;
}

.alert-popup__icon svg {
  width: 1.5rem;
  height: 1.5rem;
}

.alert-popup__icon--danger {
  color: var(--color-danger-500);
}

.alert-popup__icon--warning {
  color: var(--color-warning-500);
}

.alert-popup__body {
  flex: 1 1;
  min-width: 0;
}

.alert-popup__title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.alert-popup__temp {
  font-size: var(--font-size-sm);
  color: var(--color-gray-700);
  margin-top: 0.25rem;
}

.dark .alert-popup__temp {
  color: var(--color-gray-300);
}

.alert-popup__time {
  font-size: var(--font-size-xs);
  color: var(--color-gray-600);
  margin-top: 0.25rem;
}

.dark .alert-popup__time {
  color: var(--color-gray-400);
}

.alert-popup__dismiss {
  flex-shrink: 0;
  color: var(--color-gray-400);
  background: none;
  border: none;
  cursor: pointer;
  transition: var(--transition-fast);
}

.alert-popup__dismiss:hover {
  color: var(--color-gray-600);
}

.dark .alert-popup__dismiss:hover {
  color: var(--color-gray-200);
}

.alert-popup__dismiss svg {
  width: 1.25rem;
  height: 1.25rem;
}

/* Alerts List Modal */
.alerts-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.5);
  animation: fadeIn 0.2s ease-in-out;
}

.alerts-modal {
  background-color: #ffffff;
  border-radius: var(--radius-lg);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 600px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.2s ease-out;
  margin: auto;
}

.dark .alerts-modal {
  background-color: var(--color-slate-800);
}

.alerts-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--color-gray-200);
}

.dark .alerts-modal__header {
  border-bottom-color: var(--color-slate-700);
}

.alerts-modal__header-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.alerts-modal__header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.alerts-modal__title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.alerts-modal__count {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  padding: 0.125rem 0.5rem;
  background-color: var(--color-gray-100);
  border-radius: var(--radius-full);
}

.dark .alerts-modal__count {
  background-color: var(--color-slate-700);
}

.alerts-modal__close {
  color: var(--color-gray-400);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: var(--radius-md);
  transition: var(--transition-fast);
}

.alerts-modal__close:hover {
  color: var(--color-gray-600);
  background-color: var(--color-gray-100);
}

.dark .alerts-modal__close:hover {
  color: var(--color-gray-200);
  background-color: var(--color-slate-700);
}

.alerts-modal__tabs {
  display: flex;
  gap: 0.25rem;
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid var(--color-gray-200);
}

.dark .alerts-modal__tabs {
  border-bottom-color: var(--color-slate-700);
}

.alerts-modal__tab {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  border: none;
  cursor: pointer;
  transition: var(--transition-base);
  background-color: transparent;
  color: var(--color-gray-600);
}

.dark .alerts-modal__tab {
  color: var(--color-gray-400);
}

.alerts-modal__tab:hover {
  background-color: var(--color-gray-100);
}

.dark .alerts-modal__tab:hover {
  background-color: var(--color-slate-700);
}

.alerts-modal__tab--active {
  background-color: var(--color-primary-600);
  color: #ffffff;
}

.alerts-modal__tab--active:hover {
  background-color: var(--color-primary-700);
}

.alerts-modal__tab-count {
  padding: 0.0625rem 0.375rem;
  border-radius: 9999px;
  font-size: var(--font-size-xs);
  background-color: rgba(0, 0, 0, 0.1);
}

.alerts-modal__tab--active .alerts-modal__tab-count {
  background-color: rgba(255, 255, 255, 0.3);
}

.alerts-modal__content {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem 1.25rem;
}

.alerts-modal__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.alerts-modal__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
}

.alerts-modal__empty-icon {
  width: 3rem;
  height: 3rem;
  color: var(--color-gray-400);
  margin-bottom: 0.75rem;
}

.dark .alerts-modal__empty-icon {
  color: var(--color-gray-600);
}

.alerts-modal__empty-text {
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
}

/* ── Acknowledgement History ── */
.alert-history-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.alert-history-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: var(--radius-lg);
  border-left: 4px solid transparent;
}

.alert-history-item--danger {
  background-color: var(--color-danger-50);
  border-left-color: var(--color-danger-500);
}

.dark .alert-history-item--danger {
  background-color: rgba(220, 38, 38, 0.08);
}

.alert-history-item--warning {
  background-color: var(--color-warning-50);
  border-left-color: var(--color-warning-500);
}

.dark .alert-history-item--warning {
  background-color: rgba(234, 179, 8, 0.08);
}

.alert-history-item--default {
  background-color: var(--color-gray-50);
  border-left-color: var(--color-gray-400);
}

.dark .alert-history-item--default {
  background-color: rgba(100, 116, 139, 0.08);
}

.alert-history-item__icon {
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.alert-history-item__icon svg {
  width: 1.25rem;
  height: 1.25rem;
}

.alert-history-item__icon--danger  { color: var(--color-danger-500); }
.alert-history-item__icon--warning { color: var(--color-warning-500); }
.alert-history-item__icon--default { color: var(--color-gray-400); }

.alert-history-item__body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.alert-history-item__header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.alert-history-item__vehicle {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.alert-history-item__door {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.alert-history-item__door::before {
  content: '—';
  margin-right: 0.35rem;
  color: var(--color-gray-400);
}

.alert-history-item__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
  font-size: var(--font-size-xs);
  color: var(--color-gray-700);
}

.dark .alert-history-item__meta {
  color: var(--color-gray-300);
}

.alert-history-item__reason {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
  margin-top: 0.25rem;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-md);
  background-color: rgba(255, 255, 255, 0.6);
}

.dark .alert-history-item__reason {
  background-color: rgba(255, 255, 255, 0.05);
}

.alert-history-item__reason--empty .alert-history-item__reason-text {
  font-style: italic;
  color: var(--color-gray-400);
}

.alert-history-item__reason-label {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
  white-space: nowrap;
}

.alert-history-item__reason-text {
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
}

/* ── History Table ── */
.alert-history-table-wrapper {
  width: 100%;
  overflow-x: auto;
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-gray-200);
}

.dark .alert-history-table-wrapper {
  border-color: var(--color-slate-700);
}

.alert-history-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-sm);
}

.alert-history-table thead tr {
  background-color: var(--color-gray-50);
  border-bottom: 2px solid var(--color-gray-200);
}

.dark .alert-history-table thead tr {
  background-color: var(--color-slate-700);
  border-bottom-color: var(--color-slate-600);
}

.alert-history-table th {
  padding: 0.75rem 1rem;
  text-align: left;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-gray-500);
  white-space: nowrap;
}

.dark .alert-history-table th {
  color: var(--color-gray-400);
}

.alert-history-table tbody tr {
  border-bottom: 1px solid var(--color-gray-100);
  transition: background-color 0.15s;
}

.dark .alert-history-table tbody tr {
  border-bottom-color: var(--color-slate-700);
}

.alert-history-table tbody tr:last-child {
  border-bottom: none;
}

.alert-history-table tbody tr:hover {
  background-color: var(--color-gray-50);
}

.dark .alert-history-table tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.alert-history-table td {
  padding: 0.75rem 1rem;
  color: var(--color-text-primary);
  vertical-align: middle;
}

.alert-history-table__vehicle {
  font-weight: var(--font-weight-semibold);
}

.alert-history-table__reason {
  min-width: 200px;
  max-width: 320px;
}

.alert-history-table__reason-text {
  color: var(--color-text-primary);
  line-height: 1.4;
}

.alert-history-table__reason-empty {
  color: var(--color-gray-400);
}

/* Pagination */
.alert-history-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--color-gray-200);
  margin-top: 1rem;
}

.dark .alert-history-pagination {
  border-top-color: var(--color-slate-700);
}

.alert-history-pagination__info {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

/* Alerts toolbar (search + count) */
.alerts-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
  flex-wrap: wrap;
}

.alerts-search {
  position: relative;
  display: flex;
  align-items: center;
}

.alerts-search__icon {
  position: absolute;
  left: 0.625rem;
  width: 1rem;
  height: 1rem;
  color: var(--color-text-secondary);
  pointer-events: none;
}

.alerts-search__input {
  padding-left: 2rem;
  padding-right: 2rem;
  min-width: 200px;
}

.alerts-search__clear {
  position: absolute;
  right: 0.5rem;
  background: none;
  border: none;
  font-size: 1.1rem;
  line-height: 1;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 0.1rem 0.25rem;
}

.alerts-search__clear:hover {
  color: var(--color-text-primary);
}

/* Alerts modal search bar */
.alerts-modal__search-bar {
  padding: 0.625rem 1.25rem;
  border-bottom: 1px solid var(--color-gray-200);
}

.dark .alerts-modal__search-bar {
  border-bottom-color: var(--color-slate-700);
}

.alerts-modal__search-form {
  display: flex;
  align-items: center;
}

/* Infinite scroll sentinel & load-more indicator */
.alerts-modal__sentinel {
  padding: 0.5rem 0;
}

.alerts-modal__load-more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 0;
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
}

.alerts-modal__spinner {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid var(--color-gray-300);
  border-top-color: var(--color-primary-600);
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

.alerts-modal__end-text {
  text-align: center;
  padding: 0.5rem 0;
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ── Alert Report Modal ── */
.alert-report-modal {
  max-width: 720px;
}

.alert-report-form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--color-gray-200);
  margin-bottom: 1rem;
}

.dark .alert-report-form {
  border-bottom-color: var(--color-slate-700);
}

.alert-report-form__row {
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.alert-report-form__field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.alert-report-form__field--grow {
  flex: 1 1;
  min-width: 180px;
}

.alert-report-form__hint {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.alert-report-form__hint--error {
  color: var(--color-danger-600);
}

.dark .alert-report-form__hint--error {
  color: var(--color-danger-400);
}

.alert-report-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.alert-report-summary {
  display: flex;
  gap: 1.5rem;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  background-color: var(--color-gray-50);
  border-radius: var(--radius-lg);
}

.dark .alert-report-summary {
  background-color: rgba(255, 255, 255, 0.03);
}

.alert-report-summary__stat {
  display: flex;
  flex-direction: column;
}

.alert-report-summary__value {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.alert-report-summary__stat--danger .alert-report-summary__value {
  color: var(--color-danger-600);
}

.dark .alert-report-summary__stat--danger .alert-report-summary__value {
  color: var(--color-danger-400);
}

.alert-report-summary__stat--warning .alert-report-summary__value {
  color: var(--color-warning-600);
}

.dark .alert-report-summary__stat--warning .alert-report-summary__value {
  color: var(--color-warning-400);
}

.alert-report-summary__label {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.alert-report-table-wrapper {
  max-height: 360px;
  overflow-y: auto;
}

.alert-report-preview__note {
  margin-top: 0.5rem;
}

/* ── Vehicle Multi-Select ── */
.vehicle-multi-select {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.vehicle-multi-select__chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.375rem;
}

.vehicle-multi-select__chip {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.125rem 0.375rem 0.125rem 0.625rem;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  color: var(--color-primary-700);
  background-color: var(--color-primary-100);
  border-radius: 9999px;
}

.dark .vehicle-multi-select__chip {
  color: var(--color-primary-300);
  background-color: rgba(37, 99, 235, 0.2);
}

.vehicle-multi-select__chip-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  font-size: 0.9rem;
  line-height: 1;
  color: inherit;
  cursor: pointer;
  padding: 0;
}

.vehicle-multi-select__chip-remove:hover {
  color: var(--color-danger-600);
}

.dark .vehicle-multi-select__chip-remove:hover {
  color: var(--color-danger-400);
}

.vehicle-multi-select__clear {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

.vehicle-multi-select__clear:hover {
  color: var(--color-text-primary);
}

.vehicle-multi-select__list {
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid var(--color-gray-200);
  border-radius: var(--radius-md);
  padding: 0.375rem;
}

.dark .vehicle-multi-select__list {
  border-color: var(--color-slate-700);
}

.vehicle-multi-select__option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.5rem;
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  cursor: pointer;
}

.vehicle-multi-select__option:hover {
  background-color: var(--color-gray-100);
}

.dark .vehicle-multi-select__option:hover {
  background-color: var(--color-slate-700);
}

.vehicle-multi-select__option-plate {
  font-weight: var(--font-weight-medium);
}

.vehicle-multi-select__option-group {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.vehicle-multi-select__message {
  padding: 0.75rem 0.5rem;
  text-align: center;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/styles/alerts.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,iDAAiD;EACjD,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,wBAAwB;EACxB,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,qCAAqC,8BAA8B,EAAE;AACrE,qCAAqC,+BAA+B,EAAE;AACtE,qCAAqC,4BAA4B,EAAE;;AAEnE;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,8BAA8B;EAC9B,wCAAwC;EACxC,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;EACvC,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,+BAA+B;EAC/B,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,kCAAkC;AACpC","sourcesContent":["/**\n * Alerts Page Styles\n * Styles for the alerts management page\n */\n\n/* Page Container */\n.alerts-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n/* Header */\n.alerts-header__title {\n  font-size: var(--font-size-3xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n.alerts-header__description {\n  color: var(--color-text-secondary);\n}\n\n/* Stats Cards */\n.alerts-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n}\n\n.alerts-stat-card {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.alerts-stat-card__icon {\n  padding: 0.75rem;\n  border-radius: var(--radius-lg);\n  flex-shrink: 0;\n}\n\n.alerts-stat-card__icon svg {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.alerts-stat-card__icon--danger {\n  background-color: var(--color-danger-100);\n  color: var(--color-danger-600);\n}\n\n.dark .alerts-stat-card__icon--danger {\n  background-color: rgba(220, 38, 38, 0.2);\n  color: var(--color-danger-400);\n}\n\n.alerts-stat-card__icon--warning {\n  background-color: var(--color-warning-100);\n  color: var(--color-warning-600);\n}\n\n.dark .alerts-stat-card__icon--warning {\n  background-color: rgba(234, 179, 8, 0.2);\n  color: var(--color-warning-400);\n}\n\n.alerts-stat-card__icon--success {\n  background-color: var(--color-primary-100);\n  color: var(--color-primary-600);\n}\n\n.dark .alerts-stat-card__icon--success {\n  background-color: rgba(37, 99, 235, 0.2);\n  color: var(--color-primary-400);\n}\n\n.alerts-stat-card__value {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n.alerts-stat-card__label {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n}\n\n/* Tabs */\n.alerts-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  border-bottom: 1px solid var(--color-gray-200);\n  padding-bottom: 1rem;\n}\n\n.dark .alerts-tabs {\n  border-bottom-color: var(--color-slate-700);\n}\n\n.alerts-tab {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border-radius: var(--radius-lg);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  border: none;\n  cursor: pointer;\n  transition: var(--transition-base);\n}\n\n.alerts-tab--active {\n  background-color: var(--color-primary-600);\n  color: #ffffff;\n}\n\n.alerts-tab:not(.alerts-tab--active) {\n  background-color: var(--color-gray-200);\n  color: var(--color-gray-700);\n}\n\n.dark .alerts-tab:not(.alerts-tab--active) {\n  background-color: var(--color-slate-700);\n  color: var(--color-gray-300);\n}\n\n.alerts-tab:not(.alerts-tab--active):hover {\n  background-color: var(--color-gray-300);\n}\n\n.dark .alerts-tab:not(.alerts-tab--active):hover {\n  background-color: var(--color-slate-600);\n}\n\n.alerts-tab__count {\n  padding: 0.125rem 0.5rem;\n  border-radius: 9999px;\n  font-size: var(--font-size-xs);\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.alerts-tab--active .alerts-tab__count {\n  background-color: #ffffff;\n  color: var(--color-primary-600);\n}\n\n.alerts-tab:not(.alerts-tab--active) .alerts-tab__count {\n  background-color: var(--color-gray-300);\n}\n\n.dark .alerts-tab:not(.alerts-tab--active) .alerts-tab__count {\n  background-color: var(--color-slate-600);\n}\n\n/* Alerts List */\n.alerts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* Empty State */\n.alerts-empty {\n  text-align: center;\n  padding: 3rem 0;\n}\n\n.alerts-empty__icon {\n  width: 4rem;\n  height: 4rem;\n  margin: 0 auto 1rem;\n  color: var(--color-gray-400);\n}\n\n.dark .alerts-empty__icon {\n  color: var(--color-gray-600);\n}\n\n.alerts-empty__title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text-primary);\n  margin-bottom: 0.5rem;\n}\n\n.alerts-empty__description {\n  color: var(--color-text-secondary);\n}\n\n/* Alert Card Component */\n.alert-card {\n  border-left-width: 4px;\n  border-radius: var(--radius-lg);\n  padding: 1rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.alert-card--danger {\n  background-color: var(--color-danger-50);\n  border-left-color: var(--color-danger-500);\n}\n\n.dark .alert-card--danger {\n  background-color: rgba(220, 38, 38, 0.1);\n}\n\n.alert-card--danger:hover {\n  background-color: var(--color-danger-100);\n}\n\n.dark .alert-card--danger:hover {\n  background-color: rgba(220, 38, 38, 0.2);\n}\n\n.alert-card--warning {\n  background-color: var(--color-warning-50);\n  border-left-color: var(--color-warning-500);\n}\n\n.dark .alert-card--warning {\n  background-color: rgba(234, 179, 8, 0.1);\n}\n\n.alert-card--warning:hover {\n  background-color: var(--color-warning-100);\n}\n\n.dark .alert-card--warning:hover {\n  background-color: rgba(234, 179, 8, 0.2);\n}\n\n.alert-card--acknowledged {\n  opacity: 0.75;\n}\n\n.alert-card__content {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n\n.alert-card__icon {\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n}\n\n.alert-card__icon svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.alert-card__icon--danger {\n  color: var(--color-danger-500);\n}\n\n.alert-card__icon--warning {\n  color: var(--color-warning-500);\n}\n\n.alert-card__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.alert-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.alert-card__title {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n}\n\n.alert-card__badge {\n  display: inline-block;\n  padding: 0.125rem 0.5rem;\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n  border-radius: var(--radius-sm);\n  margin-top: 0.25rem;\n  color: #ffffff;\n}\n\n.alert-card__badge--danger {\n  background-color: var(--color-danger-500);\n}\n\n.alert-card__badge--warning {\n  background-color: var(--color-warning-500);\n}\n\n.alert-card__badge--category {\n  background-color: var(--color-primary-500);\n  margin-left: 0.25rem;\n}\n\n.alert-card__temp {\n  font-weight: var(--font-weight-bold);\n  margin-left: 0.25rem;\n}\n\n.alert-card__temp--danger {\n  color: var(--color-danger-600);\n}\n\n.dark .alert-card__temp--danger {\n  color: var(--color-danger-400);\n}\n\n.alert-card__temp--warning {\n  color: var(--color-warning-600);\n}\n\n.dark .alert-card__temp--warning {\n  color: var(--color-warning-400);\n}\n\n.alert-card__normal-range {\n  margin-left: 0.5rem;\n  color: var(--color-gray-500);\n  font-weight: var(--font-weight-normal);\n}\n\n.dark .alert-card__normal-range {\n  color: var(--color-gray-400);\n}\n\n.alert-card__details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: var(--font-size-sm);\n  color: var(--color-gray-700);\n}\n\n.dark .alert-card__details {\n  color: var(--color-gray-300);\n}\n\n.alert-card__detail-label {\n  font-weight: var(--font-weight-medium);\n}\n\n.alert-card__time-relative {\n  color: var(--color-gray-500);\n  margin-left: 0.5rem;\n}\n\n.dark .alert-card__time-relative {\n  color: var(--color-gray-400);\n}\n\n.alert-card__note {\n  font-size: var(--font-size-xs);\n  color: var(--color-gray-600);\n  font-style: italic;\n  margin-top: 0.5rem;\n}\n\n.dark .alert-card__note {\n  color: var(--color-gray-400);\n}\n\n.alert-card__status-text {\n  font-size: var(--font-size-xs);\n  margin-top: 0.25rem;\n}\n\n.alert-card__status-text--acknowledged {\n  color: var(--color-gray-600);\n}\n\n.dark .alert-card__status-text--acknowledged {\n  color: var(--color-gray-400);\n}\n\n.alert-card__status-text--resolved {\n  color: var(--color-success-600);\n}\n\n.dark .alert-card__status-text--resolved {\n  color: var(--color-success-400);\n}\n\n/* Alert Modal Component */\n.alert-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background-color: rgba(0, 0, 0, 0.5);\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.alert-modal {\n  background-color: #ffffff;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xl);\n  max-width: 42rem;\n  width: 100%;\n  max-height: 90vh;\n  overflow: auto;\n  animation: slideIn 0.3s ease-out;\n}\n\n.dark .alert-modal {\n  background-color: var(--color-slate-800);\n}\n\n.alert-modal__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1.5rem;\n  border-bottom: 1px solid var(--color-gray-200);\n}\n\n.dark .alert-modal__header {\n  border-bottom-color: var(--color-slate-700);\n}\n\n.alert-modal__title {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n.alert-modal__subtitle {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  margin-top: 0.25rem;\n}\n\n.alert-modal__subtitle--danger {\n  color: var(--color-danger-600);\n}\n\n.dark .alert-modal__subtitle--danger {\n  color: var(--color-danger-400);\n}\n\n.alert-modal__subtitle--warning {\n  color: var(--color-warning-600);\n}\n\n.dark .alert-modal__subtitle--warning {\n  color: var(--color-warning-400);\n}\n\n.alert-modal__close {\n  color: var(--color-gray-400);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.alert-modal__close:hover {\n  color: var(--color-gray-600);\n}\n\n.dark .alert-modal__close:hover {\n  color: var(--color-gray-200);\n}\n\n.alert-modal__close svg {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.alert-modal__content {\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.alert-modal__grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n}\n\n.alert-modal__field-label {\n  display: block;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-gray-600);\n  margin-bottom: 0.25rem;\n}\n\n.dark .alert-modal__field-label {\n  color: var(--color-gray-400);\n}\n\n.alert-modal__field-value {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n}\n\n.alert-modal__status-badges {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.alert-modal__status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.5rem;\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n  border-radius: 9999px;\n}\n\n.alert-modal__status-badge--acknowledged {\n  background-color: var(--color-blue-100);\n  color: var(--color-blue-700);\n}\n\n.dark .alert-modal__status-badge--acknowledged {\n  background-color: rgba(59, 130, 246, 0.2);\n  color: var(--color-blue-400);\n}\n\n.alert-modal__status-badge--resolved {\n  background-color: var(--color-success-100);\n  color: var(--color-success-700);\n}\n\n.dark .alert-modal__status-badge--resolved {\n  background-color: rgba(34, 197, 94, 0.2);\n  color: var(--color-success-400);\n}\n\n.alert-modal__status-badge--pending {\n  background-color: var(--color-gray-100);\n  color: var(--color-gray-700);\n}\n\n.dark .alert-modal__status-badge--pending {\n  background-color: var(--color-gray-700);\n  color: var(--color-gray-300);\n}\n\n.alert-modal__info-banner {\n  padding: 0.75rem;\n  border-radius: var(--radius-lg);\n  font-size: var(--font-size-sm);\n}\n\n.alert-modal__info-banner--acknowledged {\n  background-color: var(--color-blue-50);\n  color: var(--color-blue-700);\n}\n\n.dark .alert-modal__info-banner--acknowledged {\n  background-color: rgba(59, 130, 246, 0.1);\n  color: var(--color-blue-400);\n}\n\n.alert-modal__info-banner--resolved {\n  background-color: var(--color-success-50);\n  color: var(--color-success-700);\n}\n\n.dark .alert-modal__info-banner--resolved {\n  background-color: rgba(34, 197, 94, 0.1);\n  color: var(--color-success-400);\n}\n\n.alert-modal__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1.5rem;\n  border-top: 1px solid var(--color-gray-200);\n}\n\n.dark .alert-modal__footer {\n  border-top-color: var(--color-slate-700);\n}\n\n/* Alert Popup Component */\n.alert-popup {\n  border-left-width: 4px;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  padding: 1rem;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.alert-popup--exiting {\n  opacity: 0;\n  transform: translateX(100%);\n}\n\n.alert-popup--entering {\n  opacity: 1;\n  transform: translateX(0);\n  animation: slideIn 0.3s ease-out;\n}\n\n.alert-popup--danger {\n  background-color: var(--color-danger-50);\n  border-left-color: var(--color-danger-500);\n}\n\n.dark .alert-popup--danger {\n  background-color: rgba(220, 38, 38, 0.2);\n  border-left-color: var(--color-danger-700);\n}\n\n.alert-popup--warning {\n  background-color: var(--color-warning-50);\n  border-left-color: var(--color-warning-500);\n}\n\n.dark .alert-popup--warning {\n  background-color: rgba(234, 179, 8, 0.2);\n  border-left-color: var(--color-warning-700);\n}\n\n.alert-popup__content {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n\n.alert-popup__icon {\n  flex-shrink: 0;\n}\n\n.alert-popup__icon svg {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.alert-popup__icon--danger {\n  color: var(--color-danger-500);\n}\n\n.alert-popup__icon--warning {\n  color: var(--color-warning-500);\n}\n\n.alert-popup__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.alert-popup__title {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n}\n\n.alert-popup__temp {\n  font-size: var(--font-size-sm);\n  color: var(--color-gray-700);\n  margin-top: 0.25rem;\n}\n\n.dark .alert-popup__temp {\n  color: var(--color-gray-300);\n}\n\n.alert-popup__time {\n  font-size: var(--font-size-xs);\n  color: var(--color-gray-600);\n  margin-top: 0.25rem;\n}\n\n.dark .alert-popup__time {\n  color: var(--color-gray-400);\n}\n\n.alert-popup__dismiss {\n  flex-shrink: 0;\n  color: var(--color-gray-400);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.alert-popup__dismiss:hover {\n  color: var(--color-gray-600);\n}\n\n.dark .alert-popup__dismiss:hover {\n  color: var(--color-gray-200);\n}\n\n.alert-popup__dismiss svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* Alerts List Modal */\n.alerts-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background-color: rgba(0, 0, 0, 0.5);\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n.alerts-modal {\n  background-color: #ffffff;\n  border-radius: var(--radius-lg);\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 600px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  animation: slideIn 0.2s ease-out;\n  margin: auto;\n}\n\n.dark .alerts-modal {\n  background-color: var(--color-slate-800);\n}\n\n.alerts-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--color-gray-200);\n}\n\n.dark .alerts-modal__header {\n  border-bottom-color: var(--color-slate-700);\n}\n\n.alerts-modal__header-content {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.alerts-modal__header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.alerts-modal__title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n.alerts-modal__count {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  padding: 0.125rem 0.5rem;\n  background-color: var(--color-gray-100);\n  border-radius: var(--radius-full);\n}\n\n.dark .alerts-modal__count {\n  background-color: var(--color-slate-700);\n}\n\n.alerts-modal__close {\n  color: var(--color-gray-400);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: var(--radius-md);\n  transition: var(--transition-fast);\n}\n\n.alerts-modal__close:hover {\n  color: var(--color-gray-600);\n  background-color: var(--color-gray-100);\n}\n\n.dark .alerts-modal__close:hover {\n  color: var(--color-gray-200);\n  background-color: var(--color-slate-700);\n}\n\n.alerts-modal__tabs {\n  display: flex;\n  gap: 0.25rem;\n  padding: 0.75rem 1.25rem;\n  border-bottom: 1px solid var(--color-gray-200);\n}\n\n.dark .alerts-modal__tabs {\n  border-bottom-color: var(--color-slate-700);\n}\n\n.alerts-modal__tab {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.375rem 0.75rem;\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  border: none;\n  cursor: pointer;\n  transition: var(--transition-base);\n  background-color: transparent;\n  color: var(--color-gray-600);\n}\n\n.dark .alerts-modal__tab {\n  color: var(--color-gray-400);\n}\n\n.alerts-modal__tab:hover {\n  background-color: var(--color-gray-100);\n}\n\n.dark .alerts-modal__tab:hover {\n  background-color: var(--color-slate-700);\n}\n\n.alerts-modal__tab--active {\n  background-color: var(--color-primary-600);\n  color: #ffffff;\n}\n\n.alerts-modal__tab--active:hover {\n  background-color: var(--color-primary-700);\n}\n\n.alerts-modal__tab-count {\n  padding: 0.0625rem 0.375rem;\n  border-radius: 9999px;\n  font-size: var(--font-size-xs);\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.alerts-modal__tab--active .alerts-modal__tab-count {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.alerts-modal__content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem 1.25rem;\n}\n\n.alerts-modal__list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.alerts-modal__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 1rem;\n  text-align: center;\n}\n\n.alerts-modal__empty-icon {\n  width: 3rem;\n  height: 3rem;\n  color: var(--color-gray-400);\n  margin-bottom: 0.75rem;\n}\n\n.dark .alerts-modal__empty-icon {\n  color: var(--color-gray-600);\n}\n\n.alerts-modal__empty-text {\n  color: var(--color-text-secondary);\n  font-size: var(--font-size-sm);\n}\n\n/* ── Acknowledgement History ── */\n.alert-history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.alert-history-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 1rem;\n  border-radius: var(--radius-lg);\n  border-left: 4px solid transparent;\n}\n\n.alert-history-item--danger {\n  background-color: var(--color-danger-50);\n  border-left-color: var(--color-danger-500);\n}\n\n.dark .alert-history-item--danger {\n  background-color: rgba(220, 38, 38, 0.08);\n}\n\n.alert-history-item--warning {\n  background-color: var(--color-warning-50);\n  border-left-color: var(--color-warning-500);\n}\n\n.dark .alert-history-item--warning {\n  background-color: rgba(234, 179, 8, 0.08);\n}\n\n.alert-history-item--default {\n  background-color: var(--color-gray-50);\n  border-left-color: var(--color-gray-400);\n}\n\n.dark .alert-history-item--default {\n  background-color: rgba(100, 116, 139, 0.08);\n}\n\n.alert-history-item__icon {\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n}\n\n.alert-history-item__icon svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.alert-history-item__icon--danger  { color: var(--color-danger-500); }\n.alert-history-item__icon--warning { color: var(--color-warning-500); }\n.alert-history-item__icon--default { color: var(--color-gray-400); }\n\n.alert-history-item__body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.alert-history-item__header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.alert-history-item__vehicle {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n}\n\n.alert-history-item__door {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n}\n\n.alert-history-item__door::before {\n  content: '—';\n  margin-right: 0.35rem;\n  color: var(--color-gray-400);\n}\n\n.alert-history-item__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 1.5rem;\n  font-size: var(--font-size-xs);\n  color: var(--color-gray-700);\n}\n\n.dark .alert-history-item__meta {\n  color: var(--color-gray-300);\n}\n\n.alert-history-item__reason {\n  display: flex;\n  align-items: baseline;\n  gap: 0.4rem;\n  margin-top: 0.25rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-md);\n  background-color: rgba(255, 255, 255, 0.6);\n}\n\n.dark .alert-history-item__reason {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.alert-history-item__reason--empty .alert-history-item__reason-text {\n  font-style: italic;\n  color: var(--color-gray-400);\n}\n\n.alert-history-item__reason-label {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-secondary);\n  white-space: nowrap;\n}\n\n.alert-history-item__reason-text {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-primary);\n}\n\n/* ── History Table ── */\n.alert-history-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--color-gray-200);\n}\n\n.dark .alert-history-table-wrapper {\n  border-color: var(--color-slate-700);\n}\n\n.alert-history-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--font-size-sm);\n}\n\n.alert-history-table thead tr {\n  background-color: var(--color-gray-50);\n  border-bottom: 2px solid var(--color-gray-200);\n}\n\n.dark .alert-history-table thead tr {\n  background-color: var(--color-slate-700);\n  border-bottom-color: var(--color-slate-600);\n}\n\n.alert-history-table th {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-gray-500);\n  white-space: nowrap;\n}\n\n.dark .alert-history-table th {\n  color: var(--color-gray-400);\n}\n\n.alert-history-table tbody tr {\n  border-bottom: 1px solid var(--color-gray-100);\n  transition: background-color 0.15s;\n}\n\n.dark .alert-history-table tbody tr {\n  border-bottom-color: var(--color-slate-700);\n}\n\n.alert-history-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.alert-history-table tbody tr:hover {\n  background-color: var(--color-gray-50);\n}\n\n.dark .alert-history-table tbody tr:hover {\n  background-color: rgba(255, 255, 255, 0.03);\n}\n\n.alert-history-table td {\n  padding: 0.75rem 1rem;\n  color: var(--color-text-primary);\n  vertical-align: middle;\n}\n\n.alert-history-table__vehicle {\n  font-weight: var(--font-weight-semibold);\n}\n\n.alert-history-table__reason {\n  min-width: 200px;\n  max-width: 320px;\n}\n\n.alert-history-table__reason-text {\n  color: var(--color-text-primary);\n  line-height: 1.4;\n}\n\n.alert-history-table__reason-empty {\n  color: var(--color-gray-400);\n}\n\n/* Pagination */\n.alert-history-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid var(--color-gray-200);\n  margin-top: 1rem;\n}\n\n.dark .alert-history-pagination {\n  border-top-color: var(--color-slate-700);\n}\n\n.alert-history-pagination__info {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n}\n\n/* Alerts toolbar (search + count) */\n.alerts-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 1rem;\n  flex-wrap: wrap;\n}\n\n.alerts-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.alerts-search__icon {\n  position: absolute;\n  left: 0.625rem;\n  width: 1rem;\n  height: 1rem;\n  color: var(--color-text-secondary);\n  pointer-events: none;\n}\n\n.alerts-search__input {\n  padding-left: 2rem;\n  padding-right: 2rem;\n  min-width: 200px;\n}\n\n.alerts-search__clear {\n  position: absolute;\n  right: 0.5rem;\n  background: none;\n  border: none;\n  font-size: 1.1rem;\n  line-height: 1;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  padding: 0.1rem 0.25rem;\n}\n\n.alerts-search__clear:hover {\n  color: var(--color-text-primary);\n}\n\n/* Alerts modal search bar */\n.alerts-modal__search-bar {\n  padding: 0.625rem 1.25rem;\n  border-bottom: 1px solid var(--color-gray-200);\n}\n\n.dark .alerts-modal__search-bar {\n  border-bottom-color: var(--color-slate-700);\n}\n\n.alerts-modal__search-form {\n  display: flex;\n  align-items: center;\n}\n\n/* Infinite scroll sentinel & load-more indicator */\n.alerts-modal__sentinel {\n  padding: 0.5rem 0;\n}\n\n.alerts-modal__load-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem 0;\n  color: var(--color-text-secondary);\n  font-size: var(--font-size-sm);\n}\n\n.alerts-modal__spinner {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid var(--color-gray-300);\n  border-top-color: var(--color-primary-600);\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n.alerts-modal__end-text {\n  text-align: center;\n  padding: 0.5rem 0;\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── Alert Report Modal ── */\n.alert-report-modal {\n  max-width: 720px;\n}\n\n.alert-report-form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--color-gray-200);\n  margin-bottom: 1rem;\n}\n\n.dark .alert-report-form {\n  border-bottom-color: var(--color-slate-700);\n}\n\n.alert-report-form__row {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.alert-report-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.alert-report-form__field--grow {\n  flex: 1;\n  min-width: 180px;\n}\n\n.alert-report-form__hint {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n}\n\n.alert-report-form__hint--error {\n  color: var(--color-danger-600);\n}\n\n.dark .alert-report-form__hint--error {\n  color: var(--color-danger-400);\n}\n\n.alert-report-form__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n.alert-report-summary {\n  display: flex;\n  gap: 1.5rem;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  background-color: var(--color-gray-50);\n  border-radius: var(--radius-lg);\n}\n\n.dark .alert-report-summary {\n  background-color: rgba(255, 255, 255, 0.03);\n}\n\n.alert-report-summary__stat {\n  display: flex;\n  flex-direction: column;\n}\n\n.alert-report-summary__value {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n.alert-report-summary__stat--danger .alert-report-summary__value {\n  color: var(--color-danger-600);\n}\n\n.dark .alert-report-summary__stat--danger .alert-report-summary__value {\n  color: var(--color-danger-400);\n}\n\n.alert-report-summary__stat--warning .alert-report-summary__value {\n  color: var(--color-warning-600);\n}\n\n.dark .alert-report-summary__stat--warning .alert-report-summary__value {\n  color: var(--color-warning-400);\n}\n\n.alert-report-summary__label {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n}\n\n.alert-report-table-wrapper {\n  max-height: 360px;\n  overflow-y: auto;\n}\n\n.alert-report-preview__note {\n  margin-top: 0.5rem;\n}\n\n/* ── Vehicle Multi-Select ── */\n.vehicle-multi-select {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.vehicle-multi-select__chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.375rem;\n}\n\n.vehicle-multi-select__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.125rem 0.375rem 0.125rem 0.625rem;\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-primary-700);\n  background-color: var(--color-primary-100);\n  border-radius: 9999px;\n}\n\n.dark .vehicle-multi-select__chip {\n  color: var(--color-primary-300);\n  background-color: rgba(37, 99, 235, 0.2);\n}\n\n.vehicle-multi-select__chip-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  font-size: 0.9rem;\n  line-height: 1;\n  color: inherit;\n  cursor: pointer;\n  padding: 0;\n}\n\n.vehicle-multi-select__chip-remove:hover {\n  color: var(--color-danger-600);\n}\n\n.dark .vehicle-multi-select__chip-remove:hover {\n  color: var(--color-danger-400);\n}\n\n.vehicle-multi-select__clear {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n}\n\n.vehicle-multi-select__clear:hover {\n  color: var(--color-text-primary);\n}\n\n.vehicle-multi-select__list {\n  max-height: 180px;\n  overflow-y: auto;\n  border: 1px solid var(--color-gray-200);\n  border-radius: var(--radius-md);\n  padding: 0.375rem;\n}\n\n.dark .vehicle-multi-select__list {\n  border-color: var(--color-slate-700);\n}\n\n.vehicle-multi-select__option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.375rem 0.5rem;\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-primary);\n  cursor: pointer;\n}\n\n.vehicle-multi-select__option:hover {\n  background-color: var(--color-gray-100);\n}\n\n.dark .vehicle-multi-select__option:hover {\n  background-color: var(--color-slate-700);\n}\n\n.vehicle-multi-select__option-plate {\n  font-weight: var(--font-weight-medium);\n}\n\n.vehicle-multi-select__option-group {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n}\n\n.vehicle-multi-select__message {\n  padding: 0.75rem 0.5rem;\n  text-align: center;\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
